import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/publish';

@Injectable()
export class ErrorNotificationService {
  private notification: BehaviorSubject<string> = new BehaviorSubject(null);
  private notificationActive = false;
  readonly notification$: Observable<string> = this.notification.asObservable().publish().refCount();

  notify(message: string) {
    if (!this.notificationActive) {
      this.notificationActive = true;
      this.notification.next(message);
    }
  }

  clear() {
    this.notificationActive = false;
    this.notification.next('');
  }
}
